import React from 'react'
import Frisbee from 'frisbee'

import HomeIcon         from '../packs/users/img/footer/fa-home-solid.svg'
import MessageIcon      from '../packs/users/img/footer/fa-comment-dots-solid.svg'
import NotificationIcon from '../packs/users/img/footer/fa-bell-solid.svg'
import DollarIcon from '../packs/users/img/footer/fa-dollar-solid.svg';
import PhoneIcon        from '../packs/users/img/footer/fa-phone-alt-solid.svg'

import NoMessageModal from './modals/no_message'

import styled from 'styled-components'

export default class Footer extends React.Component {
  state = {
    noticeCount: 0,
    messageNoticeCount: 0,
    estimateNoticeCount: 0,
    isVisible: false
  }
  componentDidMount() {
    this.getBadgeCount()
  }
  getBadgeCount() {
    const api = new Frisbee({
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    api
      .get(`/users/badge_count`)
      .then(response => {
        this.setState({ noticeCount: response.body.news })
        this.setState({ messageNoticeCount: response.body.message })
        this.setState({ estimateNoticeCount: response.body.estimate})
      })
      .catch(err => {
        this.setState({ noticeCount: 0 })
        this.setState({ messageNoticeCount: 0})
        this.setState({ estimateNoticeCount: 0})
        console.error(err)
      })
  }
  renderIcon({ icon, path, badgeCount, label, className='', dataTarget, is_pre_member }) {
    const badge = badgeCount > 9 ? (<BadgeMore>9+</BadgeMore>) : (<Badge>{badgeCount}</Badge>);
    const handleClick = (e) => {
      if (is_pre_member) {
        e.preventDefault();
        const modal = document.getElementById('pre-member-modal-box');
        if (modal) modal.classList.add('is-show');
      } else if (!path) {
        this.setState({ isVisible: true });
      }
    }
    return (
      <FooterImage
        href={is_pre_member ? "#" : path}
        className={className}
        data-target={dataTarget}
        data-action={is_pre_member ? "open-pre-member-modal" : undefined}
        onClick={handleClick}
      >
        <FooterImageIcon src={icon} />
        {badgeCount > 0 ? badge : null}
        <FooterImageLabel>{label}</FooterImageLabel>
      </FooterImage>
    )
  }
  render() {
    const { users_message_threads_path, root_path, users_estimate_index_path, users_news_index_path, using_message, using_estimate_service, is_pre_member } = this.props
    return (
      <Container>
        <NoMessageModal
          isVisible={this.state.isVisible}
          handleOnClose={() => this.setState({ isVisible: false })}
        />
        {this.renderIcon({
          icon: HomeIcon,
          path: root_path,
          badgeCount: 0,
          label: 'ホーム',
          is_pre_member: false
        })}
        {this.renderIcon({
          icon: PhoneIcon,
          path: "#",
          badgeCount: 0,
          label: 'お問い合わせ',
          className: is_pre_member ? '' : 'js-modal-open',
          dataTarget: is_pre_member ? undefined : 'inquiry-modal-box',
          is_pre_member: is_pre_member
        })}
        {this.renderIcon({
          icon: MessageIcon,
          path: users_message_threads_path,
          badgeCount: this.state.messageNoticeCount,
          label: 'トーク',
          is_pre_member: is_pre_member
        })}
        {using_estimate_service && this.renderIcon({
          icon: DollarIcon,
          badgeCount: this.state.estimateNoticeCount,
          path: users_estimate_index_path,
          label: '見積もり・請求',
          is_pre_member: is_pre_member
        })}
        {this.renderIcon({
          icon: NotificationIcon,
          badgeCount: this.state.noticeCount,
          path: users_news_index_path,
          label: 'お知らせ',
          is_pre_member: is_pre_member
        })}
      </Container>
    )
  }
}

const FooterImageIcon = styled.img`
  display: inline-block;
  height: 6.666667vw;
  margin-bottom: 2.666667vw;
`

const FooterImageLabel = styled.span`
  display: inline-block;
  width: 100%;
  text-align: center;
  color: #333333;
  font-size: 0.625rem;
  font-weight: bold;
`

const FooterImage = styled.a`
  width: calc(100% / 5);
  height: inherit;
  text-align: center;
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 4.2666667vw 0;
`

const Badge = styled.div`
  background-color: red;
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 16px;
  color: white;
  margin: 2px;
  font-size: 9px;
  top: -8px;
  right: calc(6.66667vw - 8px);
  text-align: center;
  font-weight: bold;
`

const BadgeMore = styled.div`
  background-color: red;
  position: absolute;
  width: 20px;
  height: 16px;
  border-radius: 16px;
  color: white;
  margin: 2px;
  font-size: 9px;
  top: -8px;
  right: calc(6.66667vw - 10px);
  text-align: center;
  font-weight: bold;
`

const Container = styled.div`
  background: #ffffff;
  width: 100%;
  display: flex;
  justify-content: space-around;
`
